import { helpSupportEntriesResponseSchema } from "@/features/settings/helpSupportSchemas";
import { baseApi } from "@/shared/api/baseApi";

export const helpSupportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHelpSupportEntries: builder.query<
      ReturnType<typeof helpSupportEntriesResponseSchema.parse>,
      void
    >({
      providesTags: ["HelpSupportEntries"],
      query: () => "/v1/help-support/entries",
      transformResponse: (response) =>
        helpSupportEntriesResponseSchema.parse(response),
    }),
  }),
});

export const { useGetHelpSupportEntriesQuery } = helpSupportApi;
